// extracted by mini-css-extract-plugin
export var numpadContainer = "_pg-1";
export var phoneButton = "_pg-0";